<template>
  <div class="homeContainerBox">
    <div class="homeContainer">
      <div class="home">
        <div class="inputContainer clearfix">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="品牌">
              <el-select
                clearable
                v-model="formInline.brand"
                placeholder="请选择"
                @change="brandChange"
                @focus="brandFocusChange"
              >
                <el-option
                  v-for="item in brandList"
                  :key="item.id"
                  :label="item.filevalue"
                  :value="item.filevalue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="材质">
              <el-select
                clearable
                v-model="formInline.texture"
                placeholder="请选择"
                @change="textureChange"
                @focus="textureFocusChange"
              >
                <el-option
                  v-for="item in textureList"
                  :key="item.id"
                  :label="item.filevalue"
                  :value="item.filevalue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="标准" class="standard">
              <el-select
                clearable
                v-model="formInline.standard"
                placeholder="请选择"
                @change="standardChange"
                @focus="standardFocusChange"
              >
                <el-option
                  v-for="item in standardList"
                  :key="item.id"
                  :label="item.filevalue"
                  :value="item.filevalue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="颜色">
              <el-select
                clearable
                v-model="formInline.color"
                placeholder="请选择"
                @change="colorChange"
                @focus="colorFocusChange"
              >
                <el-option
                  v-for="item in colorList"
                  :key="item.id"
                  :label="item.filevalue"
                  :value="item.filevalue"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索标题" class="titleItem">
              <el-input placeholder="请输入" v-model="headlineValue">
              </el-input>
            </el-form-item>
            <el-form-item class="btn">
              <div class="button" @click="searchChange">搜索</div>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableContainer">
          <div class="tab-menu">
            <el-col :span="6" v-for="item in menuList" :key="item.id">
              <div
                class="title"
                id="menuTitle"
                @click="showChange(item.id)"
                :style="item.menuname !== '国标' ? 'margin-top:18px' : ''"
              >
                <!-- <i class="el-icon-remove-outline" id="el-i"></i> -->
                <i
                  :class="[
                    item.menuname !== '国标'
                      ? 'el-icon-circle-plus-outline'
                      : 'el-icon-remove-outline',
                  ]"
                  id="el-i"
                ></i>
                <span class="menuname">
                  {{ item.menuname }}
                </span>
              </div>
              <div
                class="menuBox"
                :style="{
                  display: item.menuname !== '国标' ? 'none' : 'block',
                }"
              >
                <el-menu
                  collapse-transition
                  class="el-menu-vertical-demo"
                  unique-opened
                  @open="handleOpen"
                  @select="handleSelect"
                  background-color="#ffffff
                "
                  text-color="#333333"
                  active-text-color="#e2050e"
                >
                  <el-submenu
                    :index="subItem.menuname"
                    v-for="subItem in item.Child"
                    :key="subItem.id"
                  >
                    <template slot="title">
                      <img :src="subItem.imgurl" alt="" />
                      <span class="subItem">{{ subItem.menuname }}</span>
                    </template>
                    <el-menu-item-group
                      v-for="groupItem in subItem.Child"
                      :key="groupItem.id"
                    >
                      <el-menu-item
                        @click="groupItemChange(item.menuname)"
                        :index="groupItem.menuname"
                        class="groupItem"
                      >
                        <img
                          src="./images/d_circle.png"
                          alt=""
                          class="circle"
                        />
                        <img
                          src="./images/x_circle.png"
                          alt=""
                          class="x_circle"
                          style="display: none"
                        />
                        <span class="groupItemSize">{{
                          groupItem.menuname
                        }}</span>
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                </el-menu>
              </div>
            </el-col>
          </div>
          <div class="table">
            <el-table
              v-loading="loading"
              element-loading-text="数据加载中"
              element-loading-spinner="el-icon-loading"
              :data="tableData"
              size="mini"
              stripe
              :height="tableData.length > 12 ? '587' : '100%'"
              style="width: 100%"
            >
              <el-table-column label="品牌" width="50">
                <template slot-scope="scope">
                  <img :src="scope.row.imgurlpinpai" alt="" />
                </template>
              </el-table-column>
              <el-table-column label="图片" width="59">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.imgurl"
                    alt=""
                    @click="showImgChange(scope.row.imgurl)"
                    style="cursor: pointer; margin-top: 5px"
                  />
                </template>
              </el-table-column>
              <el-table-column
                label="名称"
                width="140"
                style="text-align: center"
              >
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.pfullname }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="材质" width="70">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.caizhi }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="标准" width="70">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.standerd }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="型号" width="120">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.xinghao }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="颜色" width="70">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.color }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="单位" width="70">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.unitname }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="单价" width="70">
                <template slot-scope="scope">
                  <span>
                    {{ parseFloat(scope.row.price).toFixed(2) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="库存状态" width="80">
                <template slot-scope="scope">
                  <div class="haveStatus">
                    <span>{{
                      scope.row.levqty > 1
                        ? "充足"
                        : scope.row.levqty == 1
                        ? "紧张"
                        : "无"
                    }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="购买数量" width="130">
                <template slot-scope="scope">
                  <my-input
                    v-if="scope.row.levqty >= 1 && scope.row.isshow"
                    class="myinput"
                    v-model="scope.row.qty"
                    :max="99999"
                    :min="0"
                  ></my-input>
                  <div v-else-if="scope.row.levqty < 1">无库存</div>
                  <div
                    class="myinputText"
                    v-else-if="scope.row.isshow == false"
                  >
                    已加购
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="采购单">
                <template slot-scope="scope">
                  <img
                    v-if="scope.row.levqty >= 1 && scope.row.isshow"
                    src="./images/btn.png"
                    alt=""
                    class="btnImg"
                    @click="joinShop(scope.row)"
                    style="width: 30px; cursor: pointer; margin-top: 5px"
                  />
                  <img
                    v-else-if="scope.row.levqty < 1"
                    src="./images/wu.png"
                    alt=""
                    style="width: 30px; cursor: pointer; margin-top: 5px"
                  />
                  <img
                    v-else-if="scope.row.isshow == false"
                    src="./images/jg.png"
                    alt=""
                    class="jgImg"
                    style="width: 30px; cursor: pointer; margin-top: 5px"
                  />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="产品图片"
      :visible.sync="ImgDialogVisible"
      width="30%"
      center
    >
      <div style="text-align: center">
        <img :src="dialogImgUrl" alt="" style="width: 300px; height: 300px" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMenuList, getTypeList, getcomlist } from "@/api";
import MyInput from "@/components/MyInput";
import { mapGetters } from "vuex";
export default {
  components: { MyInput },
  data() {
    return {
      ImgDialogVisible: false,
      formInline: {
        texture: "",
        brand: "",
        standard: "",
        color: "",
      },
      loading: true,
      showMenu: false,
      tableData: [],
      menuList: [],
      fvalue1: "",
      fvalue2: "",
      fvalue3: "",
      fvalue4: "",
      fvalue5: "",
      sBrand: "",
      sTexture: "",
      sStandard: "",
      sColour: "",
      textureList: [],
      brandList: [],
      headlineValue: "",
      dialogImgUrl: "",
      colorList: [],
      standardList: [],
      JSONStr: "",
    };
  },
  methods: {
    // 图片展示
    showImgChange(imgurl) {
      this.dialogImgUrl = imgurl;
      this.ImgDialogVisible = true;
    },
    // 加入购物车
    joinShop(row) {
     console.log(this.$store.state.shopList.length);
//if (this.$store.state.shoprowCount);
    //  if (this.$store.state.shoprowCount+ 1 <= 300) {
     if (this.$store.state.shopList.length+ 1 <= 300) {
        if (row.qty == 0) {
          this.$notify.error({
            title: "错误",
            message: "数量为0,不能添加",
            duration: 1000,
          });
        } else {
          row.isshow = 1;
         // this.$store.commit("changeShoprowCount", 1);

          this.$store.commit("changeShopNum", row.qty);
          this.$store.commit("shopListIsShop", row);
         // this.$store.commit("shopListRowCount",1);
          this.$notify({
            title: "成功",
            message: "加入购物车成功",
            type: "success",
            duration: 700,
          });
        }
      } else {
        this.$notify.error({
          title: "错误",
          message: "已达购物车上限300，已无法再添加！",
          duration: 1000,
        });
      }
    },
    // 获取商品材质列表
    async getTextureList() {
      let token = window.sessionStorage.getItem("token");
      let usercode = window.sessionStorage.getItem("usercode");
      const { data: res } = await getcomlist({ usercode, flag: "1", token });
      this.textureList = JSON.parse(res);
    },
    textureFocusChange() {
      this.getTextureList();
    },
    // 获取商品品牌列表
    async getBrandList() {
      let token = window.sessionStorage.getItem("token");
      let usercode = window.sessionStorage.getItem("usercode");
      const { data: res } = await getcomlist({ usercode, flag: "2", token });
      this.brandList = JSON.parse(res);
    },
    // 获取标准列表
    async getStandardList() {
      let token = window.sessionStorage.getItem("token");
      let usercode = window.sessionStorage.getItem("usercode");
      const { data: res } = await getcomlist({ usercode, flag: "3", token });
      this.standardList = JSON.parse(res);
    },
    standardFocusChange() {
      this.getStandardList();
    },
    // 获取颜色列表
    async getColorList() {
      let token = window.sessionStorage.getItem("token");
      let usercode = window.sessionStorage.getItem("usercode");
      const { data: res } = await getcomlist({ usercode, flag: "4", token });
      this.colorList = JSON.parse(res);
    },
    colorFocusChange() {
      this.getColorList();
    },
    brandFocusChange() {
      this.getBrandList();
    },
    // 下拉选中赋值
    textureChange(text) {
      this.sTexture = text;
      if (
        this.sTexture == "" &&
        this.sBrand == "" &&
        this.sStandard == "" &&
        this.sColour == ""
      ) {
        this.getTypeLists("1", "", "", "", "", "默认", this.JSONStr);
      } else {
        this.getTypeLists(
          "2",
          this.sTexture,
          this.sBrand,
          this.headlineValue,
          this.sStandard,
          this.sColour,
          this.JSONStr
        );
      }
    },
    brandChange(text) {
      this.sBrand = text;
      if (
        this.sTexture == "" &&
        this.sBrand == "" &&
        this.sStandard == "" &&
        this.sColour == ""
      ) {
        this.getTypeLists("1", "", "", "", "", "默认", this.JSONStr);
      } else {
        this.getTypeLists(
          "2",
          this.sTexture,
          this.sBrand,
          this.headlineValue,
          this.sStandard,
          this.sColour,
          this.JSONStr
        );
      }
    },
    standardChange(text) {
      this.sStandard = text;
      if (
        this.sTexture == "" &&
        this.sBrand == "" &&
        this.sStandard == "" &&
        this.sColour == ""
      ) {
        this.getTypeLists("1", "", "", "", "", "默认", this.JSONStr);
      } else {
        this.getTypeLists(
          "2",
          this.sTexture,
          this.sBrand,
          this.headlineValue,
          this.sStandard,
          this.sColour,
          this.JSONStr
        );
      }
    },
    colorChange(text) {
      this.sColour = text;
      if (
        this.sTexture == "" &&
        this.sBrand == "" &&
        this.sStandard == "" &&
        this.sColour == ""
      ) {
        this.getTypeLists("1", "", "", "", "", "默认", this.JSONStr);
      } else {
        this.getTypeLists(
          "2",
          this.sTexture,
          this.sBrand,
          this.headlineValue,
          this.sStandard,
          this.sColour,
          this.JSONStr
        );
      }
    },
    // 点击搜索按钮
    searchChange() {
      if (
        this.formInline.texture ||
        this.formInline.brand ||
        this.formInline.standard ||
        this.formInline.color ||
        this.headlineValue
      ) {
        const { sTexture, sBrand, headlineValue, sStandard, sColour, JSONStr } =
          this;
        this.getTypeLists(
          "2",
          sTexture,
          sBrand,
          headlineValue,
          sStandard,
          sColour,
          JSONStr
        );
      } else {
        this.$notify.error({
          title: "错误",
          message: "搜索内容不能为空!",
          duration: 1000,
        });
      }
    },
    showChange(i) {
      const el_i = document.querySelectorAll("#el-i");
      const menuTitleS = document.querySelectorAll("#menuTitle");
      const boxS = document.querySelectorAll(".menuBox");
      boxS.forEach((item) => {
        item.style.display = "none";
      });
      boxS[i - 1].style.display = "block";
      el_i.forEach((item) => {
        item.className = "el-icon-circle-plus-outline";
      });
      el_i[i - 1].className = "el-icon-remove-outline";
      this.fvalue1 = menuTitleS[i - 1].innerText;
    },
    groupItemChange(name) {
      this.fvalue1 = name;
      this.sTexture = "";
      this.sBrand = "";
      this.sStandard = "";
      this.sColour = "";
      this.headlineValue = "";
      const { fvalue1, fvalue2, fvalue3, fvalue4, fvalue5, JSONStr } = this;
      this.getTypeLists(
        "1",
        fvalue1,
        fvalue2,
        fvalue3,
        fvalue4,
        fvalue5,
        JSONStr
      );
    },
    // 菜单变化 赋值
    handleSelect(index, indexPath, event) {
      document.querySelectorAll(".tab-menu .groupItem").forEach((item) => {
        item.querySelector(".circle").style.display = "inline-block";
        item.querySelector(".x_circle").style.display = "none";
        item.style.color = "rgb(51, 51, 51)";
      });
      if (index == event.index) {
        event.$el.querySelector(".circle").style.display = "none";
        event.$el.querySelector(".x_circle").style.display = "inline-block";
      }
      this.fvalue2 = indexPath[0];
      this.fvalue3 = indexPath[1];
    },
    handleOpen(index, indexPath) {
      this.fvalue2 = index;
    },
    handleChange(value) {
      console.log(value);
    },
    // 获取左边菜单栏
    async getMenuLists() {
      let token = window.sessionStorage.getItem("token");
      let usercode = window.sessionStorage.getItem("usercode");
      const { data: res } = await getMenuList({ usercode, token });
      let menuList = JSON.parse(res);
      this.menuList = menuList;
      // console.log(this.menuList);
    },
    // 获取右边商品列表
    async getTypeLists(
      flag,
      fvalue1,
      fvalue2,
      fvalue3,
      fvalue4,
      fvalue5,
      jsonstr
    ) {
      let token = window.sessionStorage.getItem("token");
      let usercode = window.sessionStorage.getItem("usercode");
      const res = await getTypeList({
        usercode,
        token,
        flag,
        fvalue1,
        fvalue2,
        fvalue3,
        fvalue4,
        fvalue5,
        jsonstr,
      });
      this.loading = false;
      this.tableData = JSON.parse(res.data);
      // console.log(this.tableData);
    },
  },
  mounted() {
    if (this.$store.state.shopList.length) {
      let shopList = [];
      let obj = {};
      this.$store.state.shopList.forEach((item) => {
        obj = {
          unitname: item.unitname,
          price: item.price,
          qty: item.qty,
          ptypeid: item.ptypeid,
        };
        shopList.push(obj);
      });
      this.JSONStr = JSON.stringify(shopList);
    }
    this.getMenuLists();
    this.getTypeLists("1", "", "", "", "", "默认", this.JSONStr);
  },
  computed: {
    ...mapGetters(["shopList_get"]),
  },
  watch: {
    shopList_get: function (val) {
      let obj = {};
      let shopList = [];
      val.forEach((item) => {
        obj = {
          unitname: item.unitname,
          price: item.price,
          qty: item.qty,
          ptypeid: item.ptypeid,
        };
        shopList.push(obj);
      });
      this.JSONStr = JSON.stringify(shopList);
      window.sessionStorage.setItem("shopList_get", this.JSONStr);
      if (
        this.sTexture ||
        this.sBrand ||
        this.sStandard ||
        this.sColour ||
        this.headlineValue
      ) {
        this.getTypeLists(
          "2",
          this.sTexture,
          this.sBrand,
          this.headlineValue,
          this.sStandard,
          this.sColour,
          this.JSONStr
        );
      } else {
        this.getTypeLists(
          "1",
          this.fvalue1,
          this.fvalue2,
          this.fvalue3,
          this.fvalue4,
          this.fvalue5,
          this.JSONStr
        );
      }
    },
  },
};
</script>
<style lang='less' scoped>
.homeContainer {
  margin-top: 15px;
  .inputContainer {
    padding-top: 30px;
    .btn {
      width: 65px;
      .button {
        width: 68px;
        height: 35px;
        border-radius: 4px;
        line-height: 35px;
        background: #e4040c;
        color: #fff;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .home {
    width: 1250px;
    padding-bottom: 10px;
    margin: 0 auto;
    .tableContainer {
      display: flex;
      .tab-menu {
        .menuname {
          font-size: 20px;
          color: #333;
        }
        .subItem {
          font-size: 16px;
        }
        .groupItemSize {
          font-size: 14px;
        }
        width: 185px;
        border: 1px solid #dcdcdc;
        padding: 15px;
        border-radius: 5px;
        margin-right: 15px;
        height: 587px;
        overflow-y: auto;
        overflow-x: hidden;
        .title {
          cursor: pointer;
          font-size: 20px;
          color: #333;
          padding-bottom: 8px;
          i {
            margin-right: 5px;
            font-size: 22px;
          }
        }
        .circle,
        .x_circle {
          width: 10px;
          vertical-align: middle;
          margin-right: 13px;
        }
        img {
          width: 25px;
          margin-right: 4px;
        }
      }
      .table {
        width: 82%;
        img {
          width: 35px;
        }
        .haveStatus,
        .noStatus {
          img {
            width: 25px;
            margin: 10px 15px 0;
          }
        }
      }
    }
    .demo-form-inline {
      float: right;
    }
  }
}
</style>